import { StyleSheet } from 'aphrodite/no-important';
import { IGenericObject } from 'models/base';
import { children, media, palette } from 'util/style-helpers';

export const style: any = (styles: IGenericObject) => {
  return StyleSheet.create({
    mainContainer: {
      flexGrow: 1,
    },

    partnerSection: {
      justifyContent: 'center',
    },

    partnerGrid: {
      display: 'grid',
      gridTemplateColumns: 'repeat(2, 1fr)',
      gridGap: '15px',

      [children('a')]: {
        display: 'flex',
        alignItems: 'center',
        minWidth: 132,
        minHeight: 66,
        overflow: 'hidden',
        background: palette.white,
      },

      [media.tablet]: {
        gridTemplateColumns: 'repeat(3, 1fr)',
        gridGap: '30px',
        justifyItems: 'center',
        [children('a')]: {
          width: 222,
          height: 113,
        },
      },

      [media.desktop]: {
        maxWidth: 980,
        [children('a')]: {
          width: 254,
          height: 130,
          [children('img')]: {
            width: '100%',
            transition: 'transform 0.3s linear',
          },
          ':hover': {
            [children('img')]: {
              transform: 'scale(1.1) translateZ(0)',
              backfaceVisibility: 'hidden',
            },
          },
        },
      },
    },

    categoryTitle: {
      marginTop: '30px',
      marginBottom: '40px',
      fontSize: '40px',
      textAlign: 'center',
    },

    partnerCategories: {
      color: 'red',
      padding: '50px 20px',
    },

    categoryContainer: {
      maxWidth: '940px',
      margin: '0 auto',
    },

    lightCategory: {
      background: palette.lightWhiteGrey,
      color: '#000',
    },

    partnerTile: {
      transition: 'all .1s ease-in-out',

      '@media (hover:hover)': {
        ':hover': {
          transform: 'scale(1.1)',
        },
      },

      ':active': {
        transform: 'scale(0.9)',
      },

      [children('img')]: {
        width: '100%',
        height: 'auto',
        maxHeight: 'initial',
        margin: '0 auto',
        flexBasis: '100%',
      },
    },
  });
};
